module.exports = __webpack_public_path__ + "static/media/3.bde43bfa.jpg";